import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { Menu, MenuItem } from '@material-ui/core';

import logo from '../../assets/images/logo.svg';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

export default function Header({ toggleMobileHeader }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const showDropdown = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const hideDropdown = () => {
    setAnchorEl(null);
  };

  const showEduDropdown = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const hideEduDropdown = () => {
    setAnchorEl(null);
  };
  return (
    <header>
      <nav className="header">
        <div className="headerPad">
          <div>
            <Link to="/">
              <img
                className="header-logo"
                src={logo}
                alt="HendrayFinvest logo"
              />
            </Link>
          </div>
          <div>
            <ul className="menu-right">
              <li>
                <Link to="/">
                  <p className="main-color light">Home</p>
                </Link>
              </li>
              <li>
                <Link to="/academy">
                  <p className="main-color light">Academy</p>
                </Link>
              </li>
              <li>
                <Link to="/about">
                  <p className="main-color light">About Us</p>
                </Link>
              </li>
              <li>
                <p onClick={showDropdown} className="main-color light">
                  Contact Us <ArrowDropDownIcon className="menu-icon" />
                </p>
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={hideDropdown}
                  style={{
                    marginTop: 60,
                  }}
                  keepMounted
                >
                  <div>
                    <MenuItem>
                      <a
                        href="mailto:getinfo@hendrayfinvest.com"
                        target="_blank"
                      >
                        getinfo@hendrayfinves
                        <br />
                        t.com
                      </a>
                    </MenuItem>
                    <MenuItem>
                      <a>
                        Whatsapp: +234 810 719 <br />
                        6205
                      </a>
                    </MenuItem>
                    <MenuItem>
                      <a>
                        Mobile: +234 810 719 <br />
                        6205
                      </a>
                    </MenuItem>
                  </div>
                </Menu>
              </li>
              <li>
                <a href="https://user-hendrayfinvest.netlify.app">
                  <p className="main-color light">Login</p>
                </a>
              </li>
              <li id="dropDown" onClick={toggleMobileHeader}>
                <MoreVertIcon />
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}
